import { Button } from '@fluentui/react-button';
import { Tooltip, makeStyles } from '@fluentui/react-components';
import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
} from '@fluentui/react-dialog';
import { useChat } from '../../../../libs/hooks';
import { getFriendlyChatName } from '../../../../libs/hooks/useChat';
import { useAppSelector } from '../../../../redux/app/hooks';
import { Delete16 } from '../../../shared/BundledIcons';

const useClasses = makeStyles({
    root: {
        width: '450px',
    },
    actions: {
        paddingTop: '10%',
    },
});

interface IEditChatNameProps {
    chatId: string;
    asLabeledButton?: boolean;
}

export const DeleteChatDialog: React.FC<IEditChatNameProps> = ({ chatId, asLabeledButton }) => {
    const classes = useClasses();
    const chat = useChat();

    const { conversations } = useAppSelector((state) => state.conversations);
    const chatName = getFriendlyChatName(conversations[chatId]);

    const onDeleteChat = () => {
        void chat.deleteChat(chatId);
    };

    return (
        <Dialog modalType="alert">
            <DialogTrigger>
                {asLabeledButton ? (
                    <Button icon={<Delete16 />} appearance="secondary" aria-label="Edit">
                        Chat löschen
                    </Button>
                ) : (
                    <Tooltip content={'Chat löschen'} relationship="label">
                        <Button
                            icon={<Delete16 />}
                            appearance="transparent"
                            style={{ color: 'inherit' }}
                            aria-label="Edit"
                        />
                    </Tooltip>
                )}
            </DialogTrigger>
            <DialogSurface className={classes.root}>
                <DialogBody>
                    <DialogTitle>Wollen Sie diesen Chat löschen: {chatName}?</DialogTitle>
                    <DialogContent>
                        Durch diese Aktion werden der Chat und alle damit verbundenen Ressourcen und gespeicherten
                        Inhalte für alle einschließlich Chat-Copilot.
                    </DialogContent>
                    <DialogActions className={classes.actions}>
                        <DialogTrigger action="close" disableButtonEnhancement>
                            <Button appearance="secondary">Abbrechen</Button>
                        </DialogTrigger>
                        <DialogTrigger action="close" disableButtonEnhancement>
                            <Button appearance="primary" onClick={onDeleteChat}>
                                Löschen
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
